import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TokenGuard } from "../App";
import { Oval } from "react-loader-spinner";
import { FiKey } from "react-icons/fi";
import { StandardURL } from "../App";


const OtpVerification = () => {
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${StandardURL}/iNyumba/auth/otp`,
        { code: otpCode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.response.token) {
        localStorage.setItem("token", response.data.response.token);
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.response.user)
        );
      }

      toast.success("OTP verification successful! Redirecting...");
      setTimeout(() => {
        navigate("../admin/home");
      }, 1500);
    } catch (error) {
      console.error(error);
      const errorMessage =
        error.response?.data?.response || "Invalid OTP. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setIsLoading(true);

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${StandardURL}/iNyumba/auth/resend-otp`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("New OTP sent successfully!");
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <TokenGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 to-blue-700 p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 space-y-8 transform transition-all duration-300 hover:scale-105">
          <div className="text-center">
            <img
              className="mx-auto h-20 w-auto mb-4"
              src="https://www.dropbox.com/scl/fi/5qeolvr9hnmg7amue63up/inyumbatwo.png?rlkey=am75yoke6inayof82d6xckeiv&raw=1"
              alt="iNyumba Logo"
            />
            <h2 className="mt-6 text-4xl font-extrabold text-gray-900">
              OTP Verification
            </h2>
            <p className="mt-2 text-md text-gray-600">
              A 5-digit code has been sent to your email.
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiKey className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              <input
                type="text"
                maxLength="5"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 5))}
                className="pl-10 appearance-none block w-full px-3 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition duration-150 ease-in-out"
                placeholder="Enter 5-digit OTP"
                required
                disabled={isLoading}
              />
            </div>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 mt-8">
              <button
                type="submit"
                disabled={isLoading || otpCode.length !== 5}
                className={`w-full sm:w-auto flex items-center justify-center py-3 px-6 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white transition duration-200 ease-in-out
                ${
                  isLoading || otpCode.length !== 5
                    ? "bg-indigo-400 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                }`}
              >
                {isLoading ? (
                  <Oval height={24} width={24} color="white" visible={true} ariaLabel="loading-indicator" secondaryColor="rgba(255,255,255,0.4)" strokeWidth={5} strokeWidthSecondary={5} />
                ) : (
                  <>
                    <FiKey className="h-5 w-5 mr-2" />
                    Verify
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={handleResendOtp}
                disabled={isLoading}
                className={`w-full sm:w-auto flex items-center justify-center py-3 px-6 border border-transparent rounded-lg shadow-sm text-lg font-medium transition duration-200 ease-in-out
                ${
                  isLoading
                    ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                    : "bg-gray-200 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                }`}
              >
                {isLoading ? (
                  <Oval height={24} width={24} color="#5D6D7E" visible={true} ariaLabel="loading-indicator" secondaryColor="rgba(93,109,126,0.4)" strokeWidth={5} strokeWidthSecondary={5} />
                ) : (
                  "Resend OTP"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </TokenGuard>
  );
};

export default OtpVerification;